// extracted by mini-css-extract-plugin
export default {"modal":"SuccessModal_modal__YwSYh","yes-btn":"SuccessModal_yes-btn__689vp"};